import { Quote } from "lucide-react";

const SpeakersSection = ({ speakers, speakersTitle }) => {
  return (
    <section className="bg-gray-100 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-end mt-6">
          <blockquote className="text-xl space-x-2 flex font-medium text-gray-600">
            <span>{speakersTitle}</span>

            <span className="text-4xl font-bold text-indigo-900">
              <Quote className=" h-6" />
            </span>
          </blockquote>
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          {speakers.map((speaker, index) => (
            <div
              key={index}
              className="bg-indigo-900 shadow-lg rounded-lg overflow-hidden text-center"
            >
              <div className="relative">
                <img
                  src={speaker.image}
                  alt={speaker.name}
                  className="w-full  h-[18rem] object-top object-cover"
                />
              </div>
              <div className=" mb-0 p-4 text-white">
                <h3 className="font-bold text-lg">{speaker.name}</h3>
                <p className="text-sm">{speaker.role}</p>
                {speaker.expertise && (
                  <p className="text-xs mt-1">{speaker.expertise}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpeakersSection;
